import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import SimpleLayout from "../../components/Layout/Simple";

const { displayName } = config;

export default function NotFound(): React.ReactNode {
  useEffect(() => {
    document.title = `${displayName}: Not found`;
  }, []);

  return (
    <SimpleLayout>
      <div>Not found</div>
    </SimpleLayout>
  );
}
